export { default } from './xml2json';